import React, { useState } from "react";
import { ConfigProvider, DatePicker } from "antd";
import locale from "antd/locale/ru_RU";
import dayjs from "dayjs";
import "dayjs/locale/ru";
import { Icon, D } from "./icons";

const { RangePicker } = DatePicker;
const FMT = "YYYY-MM-DD";

/**
 * «Когда свободен» / «Дата погрузки»: a date range (antd RangePicker, Russian locale).
 * Writes `dateFrom` / `dateTo` ("YYYY-MM-DD" or "") into the search form; past days are disabled.
 * On phones the popup shows one month (same trick as the legacy search forms).
 */
export default function DateRangeField({ label, form, setForm }) {
  const value = form.dateFrom || form.dateTo ? [form.dateFrom ? dayjs(form.dateFrom) : null, form.dateTo ? dayjs(form.dateTo) : null] : null;
  const isPhone = () => typeof window !== "undefined" && !!window.matchMedia?.("(max-width: 767px)").matches;
  const [phone, setPhone] = useState(isPhone);
  return (
    <div className="field date-range-field">
      <span>{label}</span>
      <span className="input-wrap date-range">
        <ConfigProvider locale={locale}>
          <RangePicker
            value={value}
            format="DD.MM.YYYY"
            placeholder={["С", "По"]}
            allowEmpty={[true, true]}
            variant="borderless"
            suffixIcon={<Icon d={D.calendar} />}
            disabledDate={(d) => d && d.isBefore(dayjs().startOf("day"))}
            inputReadOnly={phone}
            placement="bottomLeft"
            popupClassName={`cab-range-popup${phone ? " one-month" : ""}`}
            aria-label={label}
            onOpenChange={(open) => open && setPhone(isPhone())}
            onChange={(v) =>
              setForm((f) => ({
                ...f,
                dateFrom: v?.[0] ? v[0].format(FMT) : "",
                dateTo: v?.[1] ? v[1].format(FMT) : "",
              }))
            }
          />
        </ConfigProvider>
      </span>
    </div>
  );
}
